package ir.alirezaivaz.finglish.utils

import com.russhwolf.settings.Settings
import ir.alirezaivaz.finglish.dto.Language
import ir.alirezaivaz.finglish.dto.Theme
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

object SettingsManager {
    val settings = Settings()

    private val _theme = MutableStateFlow(getThemeFromPref())
    val theme: StateFlow<Theme> = _theme
    private val _language = MutableStateFlow(getLanguageFromPref())
    val language: StateFlow<Language> = _language
    private val _isDynamicColors = MutableStateFlow(getIsDynamicColorsFromPref())
    val isDynamicColors: StateFlow<Boolean> = _isDynamicColors

    fun getThemeFromPref(): Theme {
        val theme = settings.getString(
            AppConfig.PREF_THEME,
            Theme.getDefaultTheme().toString()
        )
        return Theme.find(theme)
    }

    private fun getLanguageFromPref(): Language {
        val languageTag = settings.getString(
            AppConfig.PREF_LANGUAGE,
            Language.DEFAULT_LANGUAGE.tag
        )
        return Language.find(languageTag)
    }

    private fun getIsDynamicColorsFromPref(): Boolean {
        return settings.getBoolean(
            AppConfig.PREF_DYNAMIC_COLORS,
            AppConfig.PREF_DYNAMIC_COLORS_DEFAULT
        )
    }

    fun updateTheme(theme: Theme) {
        _theme.value = theme
        settings.putString(AppConfig.PREF_THEME, theme.toString())
        Utils.applyTheme(theme)
    }

    fun updateLanguage(language: Language) {
        _language.value = language
        settings.putString(AppConfig.PREF_LANGUAGE, language.tag)
    }

    fun updateIsDynamicColors(value: Boolean) {
        _isDynamicColors.value = value
        settings.putBoolean(AppConfig.PREF_DYNAMIC_COLORS, value)
    }

}
